import BaseDirective from '@primevue/core/basedirective';
import KeyFilterStyle from 'primevue/keyfilter/style';

const BaseKeyFilter = BaseDirective.extend({
    style: KeyFilterStyle
});

export default BaseKeyFilter;
